import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 104 104"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#000",
      d: "M103.5.5v103H.5V.5z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "M45.328 54.424v-.728l5.194-6.496h1.12l-5.152 6.496-.546-.168h7.882v.896zM50.858 57v-2.576l.028-.896V51.26h.98V57zm3.813-6.972.616-2.576.112.588a.8.8 0 0 1-.546-.196.74.74 0 0 1-.21-.546q0-.336.21-.546.224-.21.532-.21.321 0 .518.224.21.21.21.532 0 .113-.014.224-.014.113-.056.252a3 3 0 0 1-.098.322l-.602 1.932zm2.38 0 .616-2.576.112.588a.8.8 0 0 1-.546-.196.74.74 0 0 1-.21-.546q0-.336.21-.546.224-.21.532-.21.321 0 .518.224.21.21.21.532 0 .113-.014.224-.014.113-.056.252a3 3 0 0 1-.098.322l-.602 1.932z"
    }, null, -1)
  ])))
}
export default { render: render }